<app-loading></app-loading>
<div class="check-oauth-token">
  <div>
    <div class="heading heading_standard heading_centered">
      Authorization...
    </div>
    <div class="check-oauth-token__spinner">
      <div class="lds-ring">
        <div></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
    </div>
  </div>
</div>
